<template>
    <div class="container">
        <div class="rich-text is-padded hyphenate">
            <div v-if="header" :class="headerStyle" class="title">
                <h1>
                    {{ header }}
                </h1>
            </div>
            <div v-if="subheader" class="title is-4" :class="headerStyle">
                {{ subheader }}
            </div>
            <div v-html="text" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'RichText',
    props: {
        contentData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        text() {
            if (this.contentData.content.bodytext) {
                return this.contentData.content.bodytext.replace(
                    /(?:\r\n|\r|\n)/g,
                    '<br>'
                );
            }

            return '';
        },
        header() {
            return this.contentData.content.header;
        },
        subheader() {
            return this.contentData.content.subheader;
        },
        headerStyle() {
            let position;
            let color;

            switch (this.contentData.content.headerPosition) {
                case 'right':
                    position = 'has-text-right';
                    break;
                case 'center':
                    position = 'has-text-centered';
                    break;
                default:
                    position = 'has-text-left';
            }

            switch (this.contentData.content.headerLayout) {
                case 0:
                    color = 'has-text-grey';
                    break;
                case 1:
                    color = 'has-text-grey-dark';
                    break;
                case 2:
                    color = 'has-text-primary-dark';
            }
            return [color, position];
        },
    },
};
</script>

<style lang="scss">
.cms-view-content {
    .cms-view__element {
        .hero-banner {
            @media screen and (max-width: $desktop) {
                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    font-size: inherit;
                }
            }
        }
    }

    .rich-text {
        &.hyphenate,
        .hyphenate {
            word-break: keep-all;
            hyphens: manual;
            -ms-hyphens: manual;
            -moz-hyphens: manual;
            -webkit-hyphens: manual;
        }

        &.is-padded {
            padding: 0 1rem;
        }

        p:last-child,
        ul,
        ol {
            padding-bottom: 3rem;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            @extend .title;
        }

        .subtitle {
            font-size: $size-5;
        }


        h1 {
            font-size: $size-4;
            margin-bottom: 0.5em;
        }

        h2 {
            font-size: $size-5;
        }

        h3 {
            font-size: $size-6;
        }

        h4 {
            font-size: $size-6;
        }

        h5 {
            font-size: $size-6;
        }

        h6 {
            font-size: $size-6;
        }

        p {
            font-size: $size-6;
        }

        a {
            color: $primary-dark;

            &:hover {
                color: $primary;
            }
        }

        ol,
        ul {
            padding-left: 1rem;
            padding-bottom: 0;
            list-style: disc;

            li {

                padding-bottom: 1.5em;

                &:not(:last-child) {
                    padding-bottom: 1em;
                }

                p:last-child {
                    padding-bottom: 0;
                }
            }
        }

        strong {
            font-family: MetaProMedium, Helvetica, Arial, sans-serif;
            font-weight: normal;
            color: inherit;
        }

        .title {
            margin-bottom: 0;
        }

        .title.is-3 {
            font-family: TTHovesProNormal, Helvetica, Arial, sans-serif;
            margin-bottom: 1.5rem;
        }

        .title.is-4 {
            font-family: TTHovesProNormal, Helvetica, Arial, sans-serif;
            margin-bottom: 0.75rem;
            margin-top: 0.5em;
            font-size: 1.1em;
        }

        .text-center {
            text-align: center;
        }

        .text-right {
            text-align: right;
        }

        .text-justify {
            text-align: justify;
        }
    }
}

@media screen and (min-width: $tablet) {
    .cms-view {
        .rich-text {
            &.is-padded {
                padding: 0 1.5rem;
            }

            .subtitle {
                font-size: $size-4;
            }

            h1 {
                font-size: $size-3;
            }

            h2 {
                font-size: $size-4;
            }

            h3 {
                font-size: $size-5;
            }

            h4 {
                font-size: $size-4;
            }

            h5 {
                font-size: $size-5;
            }

            h6 {
                font-size: $size-6;
            }

            p {
                font-size: $size-6;
            }
        }
    }
}
</style>
